export var REGISTRATION_REGISTER_TYPE = 'registration/register/status_changed';
export var REGISTRATION_SEND_SMS_TYPE = 'registration/sendSms/status_changed';
export var REGISTRATION_CONFIRM_PHONE_TYPE = 'registration/confirmPhone/status_changed';